module.exports = __webpack_public_path__ + "Frame51.svg?331292e4c944f9387de3367b03d10938";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Frame51.svg
// module id = 92
// module chunks = 0